export const UNCOMPLETED_OBJECTION_DESCRIPTION =
  'Sua solicitação está com o time financeiro. Atualizaremos assim que houver uma resposta.'
